import { getAuth, sendPasswordResetEmail } from 'firebase/auth'
import { useForm } from 'react-hook-form'
import { Link as ReactRouterLink, useNavigate } from 'react-router-dom'
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Heading,
  Input,
  Link,
} from '@chakra-ui/react'

interface IForgotPasswordForm {
  email: string
}

function isUserNotFoundError(error: unknown): boolean {
  return (
    error instanceof Error &&
    'code' in error &&
    error.code === 'auth/user-not-found'
  )
}

const ForgotPassword = () => {
  const {
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    register,
  } = useForm<IForgotPasswordForm>()
  const navigate = useNavigate()
  const onSubmit = async ({ email }: IForgotPasswordForm) => {
    try {
      await sendPasswordResetEmail(getAuth(), email)
    } catch (err) {
      if (isUserNotFoundError(err)) {
        setError('email', {
          message: 'User with this email does not exist',
        })
      }
      console.error(err)
    }
    navigate('/login')
  }

  return (
    <main className="flex-1 flex flex-col justify-center items-center px-2">
      <Heading size={'lg'} className="text-center" color={'black'}>
        Reset your password
      </Heading>
      <div className="mt-2">
        <Link
          as={ReactRouterLink}
          color="#6B5CE6"
          className="font-semibold"
          to="/sign-in"
        >
          Back to sign in
        </Link>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl mt={5} isInvalid={Boolean(errors.email)}>
          <FormLabel fontWeight={'bold'} htmlFor="email" color={'black'}>
            Email
          </FormLabel>
          <Input
            id="email"
            type="email"
            autoComplete="email"
            variant={'brand-solid-white'}
            {...register('email', {
              required: 'Email is required',
            })}
          />
          <FormErrorMessage>
            {errors.email && errors.email.message}
          </FormErrorMessage>
          <FormHelperText mt={4} color={'black'}>
            We will send you an email with password reset link.
          </FormHelperText>
        </FormControl>
        <Button
          className="mt-7 w-full"
          isLoading={isSubmitting}
          type="submit"
          variant="brand-solid"
        >
          Reset password
        </Button>
      </form>
    </main>
  )
}

export default ForgotPassword
